/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

import { IDnsClientPortMatch } from 'generated-types';
import { DnsClientPortMatch } from 'object-types';

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { PortMatchGenericConfigItem } from
    'ajs/modules/match/factories/port-match-generic.config-item.factory';

type IDnsClientPortMatchPartial = Omit<IDnsClientPortMatch, 'client_ports'>;

/**
 * Interface for DnsClientPortMatchConfig.
 */
export interface IDnsClientPortMatchConfig extends IDnsClientPortMatchPartial {
    client_ports?: PortMatchGenericConfigItem;
}

/**
 * @desc DnsClientPortMatch MessageItem class.
 * @author Abhinesh Gour
 */
export class DnsClientPortMatchConfigItem extends MessageItem<IDnsClientPortMatchConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: DnsClientPortMatch,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Getter for client_ports.
     */
    public get clientPorts(): PortMatchGenericConfigItem {
        return this.config.client_ports;
    }

    /** @override */
    protected requiredFields(): string[] {
        return [
            'client_ports',
        ];
    }
}
